import React, {useState} from 'react';
import Product from './Product';

const ProductList = (props) => {

  return (
    <section className="shop_section layout_padding">
      <div className="container">
        <ul style={{ listStyle: "none" }}>
          <div className="row">
            {props.products.map((product) => (
              <Product key={product.id} product={product} />
            ))}
          </div>
        </ul>
      </div>
    </section>
  );
}

export default ProductList